import React from 'react';
import PropTypes from 'prop-types';
import { DeleteOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { Button, Checkbox, Col, Form, Input, Radio, Row } from 'antd';
import FundsOriginDeclarationModal from '../../../../../../EnrollmentPage/components/steps/ComplementaryInfoStep/FundsOriginDeclarationModal';
import DeclarationModal from './DeclarationModal';
import './styles.less';
import StrDatePicker from '../../../../../../../components/common/inputs/StrDatePicker';
import ParamSelect from '../../../../../../params/components/ParamSelect';
import paramEndpoints from '../../../../../../params/paramEndpoints';
import tokens from '../../../../../../../utils/tokens';
import AloneCol from '../../../../../../../components/common/AloneCol';
import Paragraph from '../../../../../../../components/common/Paragraph';
import formUtil from '../../../../../../../utils/form';

const TaxResidenceForm = ({ taxForm }) => (
  <>
    <Form.Item shouldUpdate noStyle>
      {() =>
        taxForm.getFieldValue(['mainLegalRepresentative', 'hasForeignTaxResidences']) && (
          <Row gutter={[tokens.forms.horizontalGutterInPx]}>
            <Col span={24}>
              <Row gutter={[tokens.forms.horizontalGutterInPx]}>
                <Col lg={12} xs={24}>
                  <Form.Item
                    label="Lugar de nacimiento"
                    name={['mainLegalRepresentative', 'placeOfBirth']}
                    rules={[{ required: true }]}
                  >
                    <ParamSelect
                      paramType={paramEndpoints.COUNTRIES}
                      showSearch
                      placeholder="Seleccionar"
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Form.List
                name={['mainLegalRepresentative', 'foreignTaxResidences']}
                initialValue={[{}]}
              >
                {(foreignTaxResidences, { add, remove }) => (
                  <>
                    {foreignTaxResidences.map(({ key, name, fieldKey, ...restField }) => (
                      <>
                        <Row gutter={[tokens.forms.horizontalGutterInPx]}>
                          <Col lg={12} xs={24}>
                            <Form.Item
                              label="País de residencia"
                              name={[name, 'country']}
                              fieldKey={[fieldKey, 'country']}
                              rules={[{ required: true }]}
                              {...restField}
                            >
                              <ParamSelect
                                paramType={paramEndpoints.COUNTRIES}
                                showSearch
                                placeholder="Seleccionar"
                              />
                            </Form.Item>
                          </Col>
                          <Col lg={12} xs={24}>
                            <Form.Item
                              label="Nº de identificación"
                              name={[name, 'tin']}
                              fieldKey={[fieldKey, 'tin']}
                              rules={[{ required: true }]}
                              {...restField}
                            >
                              <Input />
                            </Form.Item>
                          </Col>
                        </Row>
                      </>
                    ))}
                    <Row gutter={[tokens.forms.horizontalGutterInPx]}>
                      <Col span={12}>
                        <Button className="swiftForm__button" type="dashed" onClick={() => add({})}>
                          + Agregar residencia
                        </Button>
                      </Col>
                      {foreignTaxResidences.length > 1 && (
                        <Col span={12}>
                          <Button
                            className="swiftForm__button"
                            type="dashed"
                            onClick={() => remove(foreignTaxResidences.length - 1)}
                          >
                            - Eliminar residencia
                          </Button>
                        </Col>
                      )}
                    </Row>
                  </>
                )}
              </Form.List>
            </Col>
          </Row>
        )
      }
    </Form.Item>

    <Row>
      <Col lg={20} xs={23}>
        <Paragraph>
          <span className="required">*</span>¿Se trata de una entidad en la cual el 50% o más de su
          renta bruta es renta pasiva y el 50% o más de sus activos poseídos durante el año
          calendario precedente son activos que generan renta pasiva o cuya tenencia tiene por
          objeto la generación de renta pasiva?
        </Paragraph>
        <Form.Item
          name={['legalPerson', 'hasMoreThanHalfAsPassiveRent']}
          rules={[{ required: true }]}
        >
          <Radio.Group
            options={[
              { label: 'Si', value: true },
              { label: 'No', value: false },
            ]}
          />
        </Form.Item>
      </Col>
    </Row>
    <Form.Item shouldUpdate noStyle>
      {() =>
        taxForm.getFieldValue(['legalPerson', 'hasMoreThanHalfAsPassiveRent']) && (
          <>
            <Row>
              <Col lg={20} xs={23}>
                <Paragraph>
                  <span className="required">*</span> ¿Existen personas naturales con Residencia
                  Tributaria distinta o adicional a la chilena que directa o indirectamente, a
                  través de sociedades y otros mecanismos, posean una participación igual o superior
                  al 10% del capital o de los derechos de voto?
                </Paragraph>
                <Form.Item
                  name={['legalPerson', 'hasPeopleWithForeignTaxResidence']}
                  rules={[
                    {
                      required: true,
                      message: 'Dato requerido',
                    },
                  ]}
                >
                  <Radio.Group
                    options={[
                      { label: 'Si', value: true },
                      { label: 'No', value: false },
                    ]}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Form.Item shouldUpdate noStyle>
              {() =>
                taxForm.getFieldValue(['legalPerson', 'hasPeopleWithForeignTaxResidence']) && (
                  <Form.List name="peopleWithForeignTaxResidence" className="taxForm">
                    {(shareholder, { add, remove }) => (
                      <>
                        {shareholder.map(({ key, name, fieldKey, ...restField }) => (
                          <React.Fragment key={key}>
                            <Row>
                              <Col span={23} className="formComplementaryInfo__form">
                                <Paragraph>
                                  <span className="required">*</span> Socio o accionista con
                                  Residencia Tributaria distinta o adicional a la chilena
                                </Paragraph>
                                <Form.Item
                                  name={[name, 'name']}
                                  fieldKey={[fieldKey, 'name']}
                                  rules={[{ required: true }]}
                                  {...restField}
                                >
                                  <Input placeholder="Nombre completo" />
                                </Form.Item>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg={11} xs={23}>
                                <Form.Item
                                  label="Domicilio"
                                  name={[name, 'address']}
                                  fieldKey={[fieldKey, 'address']}
                                  rules={[{ required: true }]}
                                  {...restField}
                                >
                                  <Input />
                                </Form.Item>
                              </Col>
                              <Col lg={{ span: 11, offset: 1 }} xs={23}>
                                <Form.Item
                                  label="Lugar de nacimiento"
                                  name={[name, 'placeOfBirth']}
                                  fieldKey={[fieldKey, 'placeOfBirth']}
                                  rules={[{ required: true }]}
                                  {...restField}
                                >
                                  <ParamSelect paramType={paramEndpoints.COUNTRIES} />
                                </Form.Item>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg={11} xs={23}>
                                <Form.Item
                                  label="Fecha de nacimiento"
                                  name={[name, 'dateOfBirth']}
                                  fieldKey={[fieldKey, 'dateOfBirth']}
                                  rules={[{ required: true }]}
                                  {...restField}
                                >
                                  <StrDatePicker
                                    className="taxForm__date"
                                    format={formUtil.date.format.day}
                                  />
                                </Form.Item>
                              </Col>
                            </Row>
                            <Form.List
                              name={[name, 'foreignTaxResidences']}
                              fieldKey={[fieldKey, 'foreignTaxResidences']}
                              className="taxForm"
                              {...restField}
                            >
                              {(taxData, { add: addTaxData, remove: removeTaxData }) => (
                                <>
                                  {taxData.map(
                                    (
                                      {
                                        key: keyTaxData,
                                        name: nameTaxData,
                                        fieldKey: fieldKeyTaxData,
                                        ...restFieldTaxData
                                      },
                                      index
                                    ) => (
                                      <React.Fragment key={keyTaxData}>
                                        <Row>
                                          <Col lg={11} xs={23}>
                                            <Form.Item
                                              label="País de Residencia"
                                              name={[nameTaxData, 'country']}
                                              fieldKey={[fieldKeyTaxData, 'country']}
                                              rules={[{ required: true }]}
                                              {...restFieldTaxData}
                                            >
                                              <ParamSelect paramType={paramEndpoints.COUNTRIES} />
                                            </Form.Item>
                                          </Col>
                                          <Col lg={{ span: 11, offset: 1 }} xs={23}>
                                            <Form.Item
                                              label="Nº de Identificación"
                                              name={[nameTaxData, 'tin']}
                                              fieldKey={[fieldKeyTaxData, 'tin']}
                                              rules={[{ required: true }]}
                                              {...restFieldTaxData}
                                            >
                                              <Input />
                                            </Form.Item>
                                          </Col>
                                          {index !== 0 && (
                                            <Col span={1}>
                                              <Button
                                                type="text"
                                                onClick={() => removeTaxData(index)}
                                              >
                                                <DeleteOutlined
                                                  style={{ color: '#B22938', marginTop: '24px' }}
                                                />
                                              </Button>
                                            </Col>
                                          )}
                                        </Row>
                                      </React.Fragment>
                                    )
                                  )}
                                  <Row>
                                    <Col span={1}>
                                      <Button
                                        className="taxForm__button"
                                        type="text"
                                        onClick={() => addTaxData({})}
                                      >
                                        <PlusCircleOutlined /> Agregar Residencia Tributaria
                                      </Button>
                                    </Col>
                                  </Row>
                                </>
                              )}
                            </Form.List>
                            <AloneCol>
                              <Form.Item>
                                <Button
                                  className="taxForm__addButton"
                                  type="dashed"
                                  onClick={() => remove(name)}
                                >
                                  - Eliminar socio o accionista
                                </Button>
                              </Form.Item>
                            </AloneCol>
                          </React.Fragment>
                        ))}
                        <AloneCol>
                          <Form.Item>
                            <Button
                              className="taxForm__addButton"
                              type="dashed"
                              onClick={() => add({})}
                            >
                              + Agregar socio o accionista
                            </Button>
                          </Form.Item>
                        </AloneCol>
                      </>
                    )}
                  </Form.List>
                )
              }
            </Form.Item>
          </>
        )
      }
    </Form.Item>
    <Row>
      <Col span={24}>
        <Form.Item
          name="acceptsFundsOriginTerms"
          rules={[{ required: true }]}
          valuePropName="checked"
        >
          <Checkbox>
            He leído y acepto la
            <FundsOriginDeclarationModal />.
          </Checkbox>
        </Form.Item>
      </Col>
    </Row>
    <Row>
      <Col span={24}>
        <Form.Item name="acceptsTerms" rules={[{ required: true }]} valuePropName="checked">
          <Checkbox>
            He leído y acepto el
            <DeclarationModal />.
          </Checkbox>
        </Form.Item>
      </Col>
    </Row>
  </>
);

TaxResidenceForm.propTypes = {
  /* eslint-disable */
  taxForm: PropTypes.objectOf(PropTypes.any).isRequired,
  /* eslint-disable */
};

export default TaxResidenceForm;
